import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const { carbon, bluegrey, blue } = colorsPalettes;

const reportRowStyles = css`
    display: flex;
    width: 100%;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    margin: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: inherit;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.2s ease-out;

    &:hover {
        background-color: ${blue[50]};
    }
`;

export const IconFrame = styled(Flex)`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border: 1px solid ${carbon[50]};
    border-radius: 6px;
    background-color: transparent;
`;

export const ReportRowButton = styled.button`
    ${reportRowStyles}
`;

export const ReportRowAnchor = styled.a`
    ${reportRowStyles}
`;

export const SummaryLine = styled.div`
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const SummaryPartText = styled(Text)<{ $highlighted: boolean }>`
    font-weight: ${({ $highlighted }) => ($highlighted ? 500 : 400)};
    color: ${({ $highlighted }) => ($highlighted ? carbon[500] : carbon[250])};
`;

export const LockedReport = styled(Flex)`
    flex-shrink: 0;
    align-items: center;
    gap: 6px;
    margin-left: auto;
`;
